import * as React from 'react';
export const PNSvg = React.forwardRef(function PNSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        fillRule: 'nonzero',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M2 2h6v6H0V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#45B2E8',
        fillRule: 'nonzero',
        d: 'M10 6h4v2.5a2 2 0 1 1-4 0V6Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        fillRule: 'nonzero',
        d: 'M14 8.5a2 2 0 1 1-4 0L12 6l2 2.5Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M1.346 5.964H0V4.036h3v-.107L.748 2.44c.267-.213.59-.36.943-.415L3 2.89V2h2v2.036h.046L8 2.08v1.04l-1.383.915H8v1.928H5v.083l2.934 1.941h-1.57L5 7.086V8H3V5.964h-.082L0 7.894v-1.04l1.346-.89Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M3 3.93v.106H1.587L.203 3.12c.13-.265.317-.497.545-.68L3 3.93Zm2-.881L6.586 2H8v.104L5.08 4.036H5v-.987ZM2.92 5.964H3v.987L1.414 8H0v-.104l2.92-1.932Zm3.493 0L8 7.014V8h-.08L5 6.07v-.106h1.413ZM8 5.427H4.444V8h-.888V5.427H0v-.854h3.556V2h.888v2.573H8v.854Z',
      }),
    ),
  );
});
PNSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PN = {
  category: 'flag',
  colorable: false,
  name: 'PN',
  svg: PNSvg,
};
